<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Payroll Process"
            />
        </div>

         <section id="basic-tabs-components">
        <div class="row match-height">
          <div class="col-12">
            <div class="card">
              <div class="card-body">

                  <ul class="nav nav-tabs">
                    <li v-for="tab in tabs" :key="tab.id" class="nav-item">
                      <a
                          :class="['nav-link', { active: activeTabId === tab.id }]"
                          @click="setActiveTab(tab)"
                      >
                        {{ tab.title }}
                      </a>
                    </li>
                  </ul>

                  <component
                      :is="activeTab"
                      @reprocess="payrollReProcessing"
                  />

              </div>
            </div>
          </div>
        </div>
      </section>

      <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import {inject, onMounted, reactive, ref, watch} from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import { computed } from 'vue';
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import DraftTab from '@/components/molecule/company/hrm-payroll/payroll/DraftTab.vue';
import PendingApprovalTab from '@/components/molecule/company/hrm-payroll/payroll/PendingApprovalTab.vue';
import ApprovalTab from '@/components/molecule/company/hrm-payroll/payroll/ApprovalTab.vue';
import StatementTab from '@/components/molecule/company/hrm-payroll/payroll/StatementTab.vue';

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const token = computed(() => localStorage.getItem('token'));
const params = ref({
  offset: 20,
});

const {
  fetchTypes,
  createPayrollProcessData
} = handleHrPayroll()

const activeTab = ref(DraftTab)
const activeTabId = ref("draft")
const tabs = [
  {id: 'draft', title: 'Draft', component: DraftTab},
  {id: 'pending_approval', title: 'Pending Approval', component: PendingApprovalTab},
  {id: 'approval', title: 'Approved', component: ApprovalTab},
  {id: 'statement', title: 'Statement', component: StatementTab},
]

const setActiveTab = (tab) => {
  router.replace({ query: { ...route.query, tab: tab.id } })
}

onMounted(() => {
  const tabFromUrl = route.query.tab
  if (tabFromUrl && tabs.find(t => t.id === tabFromUrl)) {
    activeTabId.value = tabFromUrl
    activeTab.value = tabs.find(t => t.id === tabFromUrl).component
  }
})

watch(() => route.query.tab, (newTab) => {
  if (newTab && tabs.find(t => t.id === newTab)) {
    activeTabId.value = newTab
    activeTab.value = tabs.find(t => t.id === newTab).component
  }
})

const payrollReProcessing = async (item) => {
  const confirmed = confirm("Are you sure you want to reprocess?");
  if (!confirmed) return;

  let query = `?company_id=${route.params.companyId}`;
  query += `&payroll_category=${item.payroll_category}`
  query += `&calculation_period=${item.payroll_period}`
  query += `&start_date=${item.payroll_start_date}`
  query += `&end_date=${item.payroll_end_date}`
  query += `&status=reprocess`

  await createPayrollProcessData(query).then(res => {
    if (!res.status){
      showError(res.message)
      return
    }
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

</script>

<style scoped>
.head td {
  text-align: right;
}
</style>